export const Wrapper = (elementInfo, listLength) => ({
  backgroundImage: `url(${elementInfo.background})`, 
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: elementInfo.backgroundPosition,
  border: `${elementInfo.selected ? "3px solid green" : ""}`,
  borderRadius: "5px",
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "flex-end",
  alignContent: "flex-start",
  alignItems: "flex-start",
  width: "95%",
  marginTop: "0.5vh",
  marginBottom: "0.5vh",
  minHeight: listLength <= 2 ? "30%" : "20%",
})

export const TextContainer = (elementInfo) => ({
  color: "white",
  border: elementInfo.selected ? "1px solid green" : "1px solid white",
  borderRadius: "5px",
  width: "45%",
  margin: "2.5% 2.5%",
  padding: "2px 6px",
  textAlign: "left",
  backgroundColor: elementInfo.backgroundColor == "dark" ? "rgba(200,200,200, 0.7)" : "rgba(50,50,50, 0.7)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignContent: "center",
  alignItems: "center",
})
export const TypeContainer = {
  color: "white",
  //border: "1px solid white",
  width: "50%",
  textAlign: "left",
}

export const Title = (dark) => ({
  fontSize: "18px",
  fontWeight: 500,
  borderBottom: `1px solid ${dark ? "black" : "white"}`,
  marginTop: 3
})
export const Type = {
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  textAlign: "center",
  maxWidth: "70%",
  backgroundColor: "rgba(50,50,50, 0.7)"
}
  

export const SubTitle = {
  fontSize: "15px",
  fontWeight: 400,
  textAlign: "center"
}


export const Footer = {
  fontSize: "20px",
  fontWeight: 500,
  marginTop: "2vh"
}



// WEBPACK FOOTER //
// ./src/app/catalogo/components/Ticket.styles.js